<template>
  <div class="SchoolReport">
    <div class="reportTable" v-if="reportInfo">
      <a-table :columns="columns" :dataSource="reportInfo" :rowKey="row => row.qid" :pagination="{ pageSize: 10 }" :locale="{emptyText: '该任务不包含校级报告'}">
        <div slot="PROGRESS" slot-scope="text, record" style="width: 365px">
          <a-progress :percent="parseFloat(record.PROGRESS)" :strokeWidth="6" />
        </div>
        <template slot="operation" slot-scope="text, record">
          <div style="color: #1890FF; cursor: pointer;" @click="getReportUrl(record)">查看报告</div>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import URL from '@/store/url'
  import moment  from 'moment'
  export default {
    name: 'SchoolRreport',
    data () {
      return {
        columns: [
          {
            title: '报告完成度',
            dataIndex: 'PROGRESS',
            key: 'PROGRESS',
            width: '80%',
            scopedSlots: { customRender: 'PROGRESS' }
          },
          {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            scopedSlots: { customRender: 'operation' }
          }
        ],
        reportInfo: []
      }
    },
    computed: {
      ...mapState([
        'teacherAdmin',
        'maxGrade',
        'minGrade',
        'taskReport',
        'gradeReport'
      ]),
    },
    async mounted () {
      await this.getGradeReport()
      let isHave = false
      let isHaveSchool = ['993548', '993544', '993543', '993542', '993541', '995000', '995002']
      this.taskReport.topics.split(',').map(item => {
        if (isHaveSchool.includes(item)) {
          isHave = true
        }
      })
      if (isHave && (this.gradeReport && this.gradeReport.length >= 2)) {
        this.taskReport.finish = 0
        this.taskReport.total = 0
        this.gradeReport.map(item => {
          this.taskReport.finish += parseInt(item.FINISH)
          this.taskReport.total += parseInt(item.TOTAL)
        })
        console.log(this.taskReport)
        console.log(parseFloat(this.taskReport.PROGRESS).toFixed(2))
        this.taskReport.PROGRESS = this.taskReport.PROGRESS ? parseFloat(this.taskReport.PROGRESS).toFixed(2) : parseFloat(this.taskReport.progress).toFixed(2)
        // ((this.taskReport.finish / this.taskReport.total) * 100).toFixed(2)
        this.reportInfo = [this.taskReport]
        
        console.log(this.reportInfo)
      }
    },
    methods: {
      ...mapActions([
        'getGradeReport'
      ]),
      getReportUrl(record){
          let end_time = moment(this.teacherAdmin.end_time).valueOf()
        const url = `${URL.TO_SCHOOL_REPORT}?questionnaireId=${record.qid}&school_id=${this.teacherAdmin.school_id}&endTime=${end_time}&school_name=${this.teacherAdmin.school_name}&cityId=${this.teacherAdmin.city}&token=${this.teacherAdmin.tokenValue}&teacherUid=${this.teacherAdmin.uid}&maxGrade=${JSON.parse(sessionStorage.getItem('userInfo')).max_grade}&minGrade=${JSON.parse(sessionStorage.getItem('userInfo')).min_grade}&roleId=${JSON.parse(sessionStorage.getItem('userInfo')).role_id}&starttime=${this.taskReport.start_time}&endtime=${this.taskReport.end_time}&schoolName=${this.teacherAdmin.school_name}`
        if (record.finish >= 30) {
          window.open(url)
        } else {
          this.$confirm({
            title: '报告数据未满30人',
            content: '未满30人的报告数据不具有团体代表性，请谨慎参考，确定要继续查看吗？',
            okText: '继续查看',
            cancelText: '取消',
            onOk: () => {
              window.open(url)
            }
          })
        }
      }
    }
  }
</script>

<style>
.ant-table-pagination.ant-pagination {
  float: right;
  margin: 16px 16px;
}
.SchoolReport .ant-table-thead > tr > th, .SchoolReport .ant-table-tbody > tr > td {
  padding: 16px 40px!important;
}
</style>